import React, { useState,useRef } from 'react';

import './Css/PublishPaper.css';
import { useLocation, useNavigate } from "react-router-dom";

const PublishPaper = () => {
  const navigate = useNavigate(); 
   const location = useLocation();
   const [examDate, setExamDate] = useState("");
const [examTime, setExamTime] = useState("");


  const { examId } = location.state || {};
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
const [filters, setFilters] = useState({
    taluka: '',
    cluster: '',
    school: ''
  });

const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };
const talukaOptions = ['Satara', 'Karad', 'Koregaon'];
  const clusterOptions = ['Angapur', 'Limb', 'Tarle'];
  const schoolOptions = ['School 1', 'School 2', 'School 3'];
const handleConfirm = () => {
  navigate("/dashboard/exammanagment", {
    state: {
      publishedExamId: examId,
      examDate: examDate,
      examTime: examTime
    }
  });
};


  const handleCancel = () => {
    setShowConfirmPopup(false);
  };

  const handleClose = () => {
    setShowSuccessPopup(false);
  };
const handleBackToExam = () => {
    navigate('/');
  };
  return (
    <div className="preview-paper-container">
         <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          विद्यार्थी व्यवस्थापन &gt;&gt; <span>विद्यार्थी संपादन करा</span>
        </h3>
         
          <div className="preview-publish-button">
        <button onClick={() => setShowConfirmPopup(true)}>निश्चित करा </button>
        </div>
      </div>
      <header className="preview-header">
       
        <div className="preview-title">
          <h2>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा – इयत्ता पाचवी</h2>
          
        </div>
        <div className="preview-header-right">
          (गुण-४०)
        </div>
      </header>

      <section className="preview-instructions">
        <strong>सामान्य सूचना:-</strong>
        <ol>
          <li>परीक्षा एकूण १०० गुणांची असेल.</li>
          <li>एकूण ४ विषय असतील – मराठी, इंग्रजी, गणित आणि बुद्धिमत्ता चाचणी..</li>
          <li>प्रत्येक विषयामध्ये २५ प्रश्न असतील. प्रत्येक प्रश्न १ गुणाचा असेल.</li>
          <li>परीक्षेची एकूण वेळ ६० मिनिटे आहे.</li>
          <li>चुकीच्या उत्तरासाठी नकारात्मक गुण (Negative Marks) दिले जाणार नाहीत.</li>
        </ol>
      </section>

      <section className="preview-questions">
        <div className="preview-question">
          <p>१) आरोग्यासाठी आपण काय करावे ?
            <ul>
              <li>A) जास्तीत जास्त झोपावे</li>
              <li>B) भरपूर खेळावे</li>
              <li>C) गोड खावे</li>
              <li>D) आराम करावा</li>
            </ul>
          </p>
        </div>

        {/* Question 2 */}
        <div className="preview-question">
          <p>२) पुढीलपैकी कोणता सण साजरा केला जातो ?
            <ul>
              <li>A) नारळीपोर्णिमा</li>
              <li>B) ख्रिसमस</li>
              <li>C) पाडवा</li>
              <li>D) होळी</li>
            </ul>
          </p>
        </div>

        {/* Question 3 */}
        <div className="preview-question">
          <p>३) आपल्या शाळेमध्ये आपण कोणकोणते खेळ खेळतो ?
            <ul>
              <li>A) कबड्डी</li>
              <li>B) खो-खो</li>
              <li>C) क्रिकेट</li>
              <li>D) वरील सर्व</li>
            </ul>
          </p>
        </div>

        {/* Question 4 */}
        <div className="preview-question">
          <p>४) खालीलपैकी कोणती सणासुदीची गोष्ट आहे ?
            <ul>
              <li>A) नारळ</li>
              <li>B) आंबा</li>
              <li>C) दिवा</li>
              <li>D) फुलं</li>
            </ul>
          </p>
        </div>

        {/* Question 5 */}
        <div className="preview-question">
          <p>५) पावसाळ्यात आपण कोणते कपडे परिधान करतो ?
            <ul>
              <li>A) पावसाळी कोट, छत्री</li>
              <li>B) उन्हाळी कपडे</li>
              <li>C) हिवाळी कपडे</li>
              <li>D) वरीलपैकी काहीही नाही</li>
            </ul>
          </p>
        </div>
      </section>

     

      {/* Confirm Popup */}
      {showConfirmPopup && (
        <div className="confirm-popup-overlay">
          <div className="confirm-popup-box">
            <h2 className="confirm-popup-title">तुम्हाला ही परीक्षा प्रकाशित करायची खात्री आहे का?</h2>
            <p className="confirm-popup-message">
              "एकदा प्रकाशित झाल्यानंतर, ही परीक्षा सर्व संस्थाना दिसू लागेल आणि ती संपादित करता येणार नाही."
            </p >
            <p className="confirm-popup-message">कृपया पुढे जाण्यापूर्वी परीक्षेची तारीख आणि वेळ प्रविष्ट करा</p>
          <div className='paper-input'>
  <label>दिनांक</label>
  <input
    type="date"
    value={examDate}
    onChange={(e) => setExamDate(e.target.value)}
  />
</div>

<div className='paper-input'>
  <label>वेळ</label>
  <input
    type="time"
    value={examTime}
    onChange={(e) => setExamTime(e.target.value)}
  />
</div>

            <div className="confirm-popup-actions">
              <button className="confirm-popup-cancel" onClick={handleCancel}>रद्द करा </button>
              <button className="confirm-popup-confirm" onClick={handleConfirm}>होय, परीक्षा जाहीर करा </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublishPaper;
